// src/components/StoreInfo.js
import React from "react";
import "../styles/StoreInfo.css";

const StoreInfo = () => {
  return (
    <section className="store-info-section">
      <div className="store-info-container">
        {/* Cartel identificativo */}
        <div className="store-banner">
          <img
            // src="/images/logo-tienda.webp"
            alt="Cartel de la Tienda"
            className="store-banner-image"
            loading="lazy"
            onError={(e) => {
              e.target.src = "/images/placeholder.webp";
              e.target.onerror = null;
            }}
          />
        </div>

        {/* Información de la tienda */}
        <div className="store-details">
          <h2 className="store-title">🏪 Sobre Nuestra Tienda</h2>
          <p className="store-description">
            Somos una tienda comprometida con ofrecer productos de calidad al
            mejor precio. Nuestro objetivo es brindar la mejor experiencia de
            compra a nuestros clientes, con atención personalizada y productos
            garantizados.
          </p>

          <div className="store-features">
            <div className="feature">
              <span className="feature-icon">✅</span>
              <span>Productos 100% originales</span>
            </div>
            <div className="feature">
              <span className="feature-icon">💳</span>
              <span>Aceptamos múltiples formas de pago</span>
            </div>
          </div>
        </div>

        {/* Contacto y Atención */}
        <div className="store-contact">
          <h3 className="contact-title">📞 Contacto y Atención</h3>
          <div className="contact-info">
            <p>
              <strong>📍 Dirección:</strong> Calle ?????? #123, Sagua la Grande.Villa Clara
            </p>
            <p>
              <strong>📱 Teléfono:</strong> +535486685
            </p>
            <p>
              <strong>✉️ Email:</strong> tienda@ejemplo.com
            </p>
            <p>
              <strong>⏰ Horario:</strong>
              <p>
                <strong></strong> Lunes a Viernes: 8am - 3pm
              </p>
              <p>
                <strong></strong> Sábados: 8am - 12m
              </p>
            </p>
          </div>
          {/* <div className="social-links">
            <a href="#" className="social-link">
              📘 Facebook
            </a>
            <a href="#" className="social-link">
              📷 Instagram
            </a>
            <a href="#" className="social-link">
              💬 WhatsApp
            </a>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default StoreInfo;
